import React from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  TextField
} from "@material-ui/core";
import { callPoints, flights, insiders, prmTypes } from "../../mocks";
import { createStyles, makeStyles } from "@material-ui/core/styles";

export default function PrmForm(props) {
  const classes = styles();
  const { passenger, onSavePress, isCreate } = props;

  return (
    <form autoComplete={false} noValidate className={classes.formContainer}>
      <Grid
        container
        direction={"column"}
        justify="center"
        alignItems="flex-start"
      >
        <Grid
          container
          direction={"row"}
          justify={"space-between"}
          alignItems="center"
          className={classes.lineContainer}
        >
          <TextField
            id="name"
            defaultValue={
              isCreate ? null : `${passenger.name} ${passenger.surname}`
            }
            placeholder={"Nome Cognome"}
            className={classes.fullInput}
          />
        </Grid>
        <Grid
          container
          direction={"row"}
          justify={"space-between"}
          alignItems="flex-end"
          className={classes.lineContainer}
        >
          <TextField
            id="type"
            defaultValue={isCreate ? null : passenger.type}
            select
            label={"Tipologia PRM"}
            //value={passenger.type}
            hiddenLabel={false}
            className={classes.leftInput}
            //onChange={handleChange}
          >
            {prmTypes.map(type => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            id="flight"
            defaultValue={isCreate ? null : flights[1].code}
            select
            label={"Volo"}
            className={classes.rightInput}
            //onChange={handleChange}
          >
            {flights.map(flight => (
              <MenuItem key={flight.code} value={flight.code}>
                {flight.code}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid
          container
          direction={"row"}
          justify={"space-between"}
          alignItems="flex-end"
          className={classes.lineContainer}
        >
          <FormControlLabel
            control={
              <Checkbox
                //checked={true}
                color="primary"
                //onChange={handleChange('checkedA')}
                value="checkedA"
              />
            }
            label="Assegna Station"
          />
          <TextField
            id="station"
            select
            label={"N° Station"}
            className={classes.fullInput}
            //onChange={handleChange}
          >
            {[1, 2, 3, 4, 5].map(station => (
              <MenuItem key={station} value={station}>
                {station}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid
          container
          direction={"row"}
          justify={"space-between"}
          alignItems="center"
          className={classes.lineContainer}
        >
          <TextField
            id="filled-select-currency"
            select
            label={"Punto Chiamata"}
            //value={passenger.type}
            hiddenLabel={false}
            className={classes.callPointInput}
            //onChange={handleChange}
          >
            {callPoints.map(point => (
              <MenuItem key={point} value={point}>
                {point}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            id="pickup-time"
            label={"Orario"}
            className={classes.fullInput}
            type="time"
            //onChange={handleChange}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              step: 300 // 5 min
            }}
          />
        </Grid>
        <Grid
          container
          direction={"row"}
          justify={"space-between"}
          alignItems="flex-end"
          className={classes.lineContainer}
        >
          <FormControlLabel
            control={
              <Checkbox
                //checked={true}
                color="primary"
                //onChange={handleChange('checkedA')}
                value="checkedA"
              />
            }
            label="Assegna Addetto"
          />
          <TextField
            id="filled-select-currency"
            select
            label={"Nome Operatore"}
            className={classes.fullInput}
            //onChange={handleChange}
          >
            {insiders.map(insider => (
              <MenuItem key={insider} value={insider}>
                {insider}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid
          container
          direction={"row"}
          justify={"space-between"}
          alignItems="center"
          className={classes.lineContainer}
        >
          <TextField
            id="note"
            placeholder={"Note"}
            className={classes.fullInput}
          />
        </Grid>
        <Grid
          container
          direction={"row"}
          justify={"space-between"}
          alignItems="center"
          className={classes.lineContainer}
        >
          <TextField
            id="zone"
            select
            label={"Zona di Accoglienza"}
            className={classes.fullInput}
            //onChange={handleChange}
          >
            {callPoints.map(point => (
              <MenuItem key={point} value={point}>
                {point}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid
          container
          direction={"row"}
          justify={"space-between"}
          alignItems="center"
          className={classes.lineContainer}
        >
          <Button
            className={classes.saveButton}
            variant="contained"
            onClick={() => onSavePress()}
            color="secondary"
          >
            SALVA
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}

const styles = makeStyles(theme =>
  createStyles({
    formContainer: {
      padding: 16,
      paddingTop: 0
    },
    fullInput: {
      flex: 1
    },
    lineContainer: {
      marginTop: 16
    },
    saveButton: {
      color: theme.palette.white
    },
    leftInput: {
      flex: 1,
      paddingRight: 5
    },
    rightInput: {
      flex: 1,
      paddingLeft: 5
    },
    callPointInput: {
      flex: 2,
      paddingRight: 10
    }
  })
);
